var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBronze1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 634,
    viewBox: "0 0 550 634",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.800049 475.5V158.5L275.3 0L549.8 158.5V475.5L275.3 634L0.800049 475.5Z",
    fill: "#E06A36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.3 634L549.8 475.5L500.8 447.2L295.3 565.9C282.9 573 275.3 586.2 275.3 600.5V634Z",
    fill: "#9F3A22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.800049 475.5L275.3 634V600.5C275.3 586.2 267.7 573 255.3 565.9L69.8 458.7C57.4 451.6 42.2 451.6 29.9 458.7L0.800049 475.5Z",
    fill: "#E0A33F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M275.3 33.5V0L0.800049 158.5L29.8 175.3C42.2001 182.4 57.4 182.4 69.7 175.3L255.3 68.1C267.7 61 275.3 47.8 275.3 33.5Z",
    fill: "#EDD6BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M549.8 475.5V158.5L520.8 175.3C508.4 182.4 500.8 195.6 500.8 209.9V447.2L549.8 475.5Z",
    fill: "#9F3A22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.3 11.5L539.8 164.2V469.6L275.3 622.4L10.8 469.7V164.3L275.3 11.5ZM275.3 0L0.800049 158.5V475.5L275.3 634L549.8 475.5V158.5L275.3 0Z",
    fill: "#E06A36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M452.1 197.2L324.5 123.5C309.6 114.9 292.6 110.3 275.4 110.3C258.2 110.3 241.2 114.9 226.3 123.5L98.7 197.2C88.7 203 82.5 213.7 82.5 225.2V296.7C82.5 322.3 93 346.8 111.3 364.5V369.7C111.3 406.2 130.9 440.2 162.4 458.4L275.4 523.7L388.4 458.4C420.8 439.7 438.9 406.4 439.5 364.5C457.9 346.7 468.3 322.3 468.3 296.7V225.2C468.3 213.7 462.1 202.9 452.1 197.2Z",
    fill: "#1C1128"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M275.3 323L120.3 235.8V296.7C120.3 316.8 131 335.4 148.4 345.4L275.2 418.6L402 345.4C419.4 335.3 430.1 316.8 430.1 296.7V235.8L275.3 323Z",
    fill: "#342A44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M275.3 418.6L149.2 345.8V369.7C149.2 392.8 161.4 414 181.3 425.5L275.3 479.8L369.3 425.5C389.2 414 401.4 392.8 401.4 362.5V345.8L275.3 418.6Z",
    fill: "#342A44"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M420.3 252.9V296.7C420.3 313.2 411.4 328.5 397.2 336.8L396.5 337.2L391.5 340.1V345.9V362.6C391.5 387.9 382.1 406.7 364.4 416.9L275.4 468.3L186.4 416.9C169.7 407.3 159.3 389.2 159.3 369.8V345.9V340L154.3 337.1L153.6 336.7C139.3 328.5 130.5 313.1 130.5 296.6V252.8L270.6 331.6L275.5 334.4L280.4 331.6L420.3 252.9ZM430.3 235.8L275.3 323L120.3 235.8V296.7C120.3 316.8 131 335.4 148.4 345.4L149.1 345.8V369.7C149.1 392.8 161.3 414 181.2 425.5L275.2 479.8L369.2 425.5C389.1 414 401.3 392.8 401.3 362.5V345.8L402 345.4C419.4 335.3 430.1 316.8 430.1 296.7V235.8H430.3Z",
    fill: "#443B59"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M143.8 214.9L275.3 290.8L406.8 214.9L305.4 156.4C286.7 145.6 263.8 145.6 245.1 156.4L143.8 214.9Z",
    fill: "#698445"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M305.5 156.4C296.2 151 285.8 148.3 275.4 148.3V290.9L406.9 215L305.5 156.4Z",
    fill: "#1F4927"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M275.3 235.8L149.1 218L275.3 290.9L401.5 218L275.3 235.8Z",
    fill: "#143321"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M275.3 158.3C284.1 158.3 292.8 160.6 300.4 165L386.8 214.9L275.3 279.3L163.8 214.9L250.2 165C257.8 160.6 266.5 158.3 275.3 158.3ZM275.3 148.3C264.9 148.3 254.5 151 245.2 156.4L143.8 214.9L275.3 290.8L406.8 214.9L305.4 156.4C296.1 151 285.7 148.3 275.3 148.3Z",
    fill: "#2B5E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze1);
export default __webpack_public_path__ + "static/media/bronze-1.f4a5615366a7162c5cbe84a8fe3e3b72.svg";
export { ForwardRef as ReactComponent };